import { NavLink, Outlet } from "react-router-dom";
import { History, LayoutGrid, LogOut, Send, Users, Users2 } from "lucide-react";
import { BrandMark } from "@/components/brand-mark";
import { cn } from "@/lib/cn";
import { Button } from "@/components/ui/button";
import { useLogout, useSession } from "@/lib/session";

const NAV = [
    { to: "/", label: "Tổng quan", Icon: LayoutGrid, end: true },
    { to: "/accounts", label: "Tài khoản Zalo", Icon: Users, end: false },
    { to: "/groups", label: "Nhóm", Icon: Users2, end: false },
    { to: "/campaigns", label: "Chiến dịch", Icon: Send, end: false },
    { to: "/history", label: "Lịch sử gửi", Icon: History, end: false },
];

export function AppLayout() {
    const { data: user } = useSession();
    const logout = useLogout();

    return (
        <div className="flex h-full">
            <aside className="flex w-60 shrink-0 flex-col border-r border-line bg-surface">
                <div className="flex items-center gap-2.5 px-5 py-5">
                    <div className="flex size-8 items-center justify-center rounded-lg bg-brand p-1.5 text-white">
                        <BrandMark />
                    </div>
                    <span className="font-semibold text-ink">ZSchedule</span>
                </div>

                <nav className="flex-1 space-y-0.5 px-3">
                    {NAV.map(({ to, label, Icon, end }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={end}
                            className={({ isActive }) =>
                                cn(
                                    "flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition",
                                    isActive
                                        ? "bg-brand-soft font-medium text-brand"
                                        : "text-ink-muted hover:bg-surface-muted hover:text-ink",
                                )
                            }
                        >
                            <Icon className="size-4" aria-hidden />
                            {label}
                        </NavLink>
                    ))}
                </nav>

                <div className="border-t border-line px-3 py-3">
                    <p className="truncate px-3 pb-2 text-xs text-ink-muted">{user?.username}</p>
                    <Button
                        variant="ghost"
                        size="sm"
                        className="w-full justify-start"
                        loading={logout.isPending}
                        onClick={() => logout.mutate()}
                    >
                        <LogOut className="size-4" aria-hidden />
                        Đăng xuất
                    </Button>
                </div>
            </aside>

            <main className="flex-1 overflow-y-auto">
                <Outlet />
            </main>
        </div>
    );
}

export function PageHeader({ title, description, action }: { title: string; description?: string; action?: React.ReactNode }) {
    return (
        <div className="flex items-start justify-between gap-4 border-b border-line bg-surface px-8 py-5">
            <div>
                <h1 className="text-lg font-semibold text-ink">{title}</h1>
                {description && <p className="mt-0.5 text-sm text-ink-muted">{description}</p>}
            </div>
            {action && <div className="shrink-0">{action}</div>}
        </div>
    );
}
